import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http'
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app.routing';
import { MyHttpInterceptor } from './http-interceptor'

import { AppComponent } from './app.component';
import { BodyComponent } from './components/body/body.component';
import { ErrorComponent } from './components/error/error.component';
import { LoginComponent } from './components/login/login.component';
import { CreateComponent } from './components/create/create.component';
import { BackgroundComponent } from './components/gallery/background/background.component';
import { ClipartComponent } from './components/gallery/clipart/clipart.component';
import { DrawingBoardComponent } from './components/drawing-board/drawing-board.component';
import { SummaryComponent } from './components/summary/summary.component';
import { ReviewComponent } from './components/review/review.component';
import { BrowseComponent } from './components/browse/browse.component';


import { ExternalDirective } from './directives/external.directive';
import { WindowRef } from './directives/WindowRef';


import { GlobalService } from './services/global.service';
import { ApiService } from './services/api.service';
import { ResourceService } from './services/resource.service';

import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
//import { ColorPickerModule } from 'ngx-color-picker';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { TimingComponent } from './components/timing/timing.component';
import { PlayersComponent } from './components/players/players.component';
import { PosterComponent } from './components/gallery/poster/poster.component';

//import { ColorPickerModule } from './custom-libs/ngx-color-picker-mod/lib/color-picker.module';
import { FilenamePipe } from './pipes/filename/filename.pipe';


@NgModule({
  declarations: [
    AppComponent,
    BodyComponent,
    ErrorComponent,
    LoginComponent,
    CreateComponent,
    BackgroundComponent,
    ClipartComponent,
    DrawingBoardComponent,
    SummaryComponent,
    ReviewComponent,
    BrowseComponent,
    TimingComponent,
    PlayersComponent,
    ExternalDirective,
    PosterComponent,
    FilenamePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    //ColorPickerModule,
    LoadingModule.forRoot({
      backdropBackgroundColour: 'rgba(255,255,255,0)',
      animationType: ANIMATION_TYPES.rectangleBounce
    }),
    NgxMyDatePickerModule.forRoot()
  ],
  providers: [GlobalService, 
              ResourceService, 
              ApiService, 
              WindowRef,
              {
                provide: HTTP_INTERCEPTORS, 
                useClass: MyHttpInterceptor, 
                multi: true 
              }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts